import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  IconButton,
  Stack,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ToastContainer, toast } from "react-toastify";
import { getCompetition } from "../../api/getCompetition";
import CompetitionVoteAdjustmentPanel from "../../component/admin/competitions/CompetitionVoteAdjustmentPanel";

export default function CompetitionVoteAdjust() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(true);
  const [competition, setCompetition] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getCompetition(id, token);
        if (!data.success) {
          toast.error(data.message);
          navigate("/admin/dashboard/competitions");
          return;
        }
        setCompetition(data.data);
      } catch (e) {
        toast.error(e?.response?.data?.message || "Failed to load competition");
        navigate("/admin/dashboard/competitions");
      } finally {
        setLoading(false);
      }
    };
    if (id && token) load();
  }, [id, token, navigate]);

  return (
    <>
      <ToastContainer />
      <Backdrop open={loading} sx={{ color: "#fff", zIndex: 9999 }}>
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 2 }}>
          <IconButton onClick={() => navigate("/admin/dashboard/competitions")}>
            <ArrowBackIcon />
          </IconButton>
          <Box>
            <Typography variant="h1" component="h1" sx={{ fontSize: 22 }}>
              Vote adjustment
            </Typography>
            <Typography sx={{ color: "#6b7280", fontSize: 13 }}>
              {competition?.name || "Competition"} · pre-round admin controls
            </Typography>
          </Box>
        </Stack>
        {!loading && competition ? (
          <Box sx={{ maxWidth: 920 }}>
            <CompetitionVoteAdjustmentPanel
              competitionId={id}
              token={token}
              competitionStatus={competition.status}
              finalNightStatus={competition.final_night_status || "off"}
            />
          </Box>
        ) : null}
      </Box>
    </>
  );
}
